import { render, staticRenderFns } from "./turnovertierTab.vue?vue&type=template&id=2cacd331&lang=pug"
import script from "./turnovertierTab.vue?vue&type=script&lang=js"
export * from "./turnovertierTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports